/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import UserAllergies from './user-allergies';
import UserAllergiesDetail from './user-allergies-detail';
import UserAllergiesUpdate from './user-allergies-update';
import UserAllergiesDeleteDialog from './user-allergies-delete-dialog';

const UserAllergiesRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<UserAllergies />} />
    <Route path="new" element={<UserAllergiesUpdate />} />
    <Route path=":id">
      <Route index element={<UserAllergiesDetail />} />
      <Route path="edit" element={<UserAllergiesUpdate />} />
      <Route path="delete" element={<UserAllergiesDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default UserAllergiesRoutes;
